import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({ standalone: false,
  selector: 'irb-dialog-washsale-info',
  templateUrl: './dialog-washsale-info.component.html',
  styleUrls: ['./dialog-washsale-info.component.scss','../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogWashSaleComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<DialogWashSaleComponent>) {}

  ngOnInit() {    
  }

  close() {
    this.dialogRef.close();
  }
}
